import { render } from "./TransferHistory.vue?vue&type=template&id=75c33930&scoped=true"
import script from "./TransferHistory.vue?vue&type=script&lang=js"
export * from "./TransferHistory.vue?vue&type=script&lang=js"

import "./TransferHistory.vue?vue&type=style&index=0&id=75c33930&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c33930"]])

export default __exports__